import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_QUALITY_SCORE_TOGGLE = defineFcm('starfish_petition_quality_score_toggle')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Petition Quality Score',
		description:
			'Feature toggle for generating the petition quality score on petition publish and returning it for the starter onboarding page',
		mergeLogic: 'Needs combination of both country code and locale to be enabled',
		import: false,
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
